import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=79d9b76e&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=79d9b76e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d9b76e",
  null
  
)

export default component.exports